module.exports = __webpack_public_path__ + "img/controller-save.14a5cdb9.svg";